import React, { useState, useEffect } from "react";
import FeedSidebar from "./FeedSidebar";
import FeedContainer from "./FeedContainer";
import MobileWidgetDrawer from "./MobileWidgetDrawer";
import { usePresence } from "../../hooks/usePresence";
import { sidebarApi } from "../../services/api/sidebarApi";
import "./FeedPage.css";

const FeedPage = () => {
  // Track user presence (heartbeat every 30s)
  usePresence();

  const [widgets, setWidgets] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Handle screen resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Load widgets data for mobile drawer
  useEffect(() => {
    if (isMobile) {
      loadWidgets();
    }
  }, [isMobile]);

  const loadWidgets = async () => {
    try {
      const response = await sidebarApi.getAllWidgets({
        includeOnlineFriends: true,
        includeSuggestions: true,
        includeTrendingTopics: true,
        includeStats: true,
        includeCollaborationOpportunities: true,
        onlineFriendsLimit: 5,
        suggestionsLimit: 15,
        trendingLimit: 5,
        collaborationLimit: 3,
      });
      setWidgets(response.data.data);
    } catch (error) {
      // Silent fail - mobile widgets are not critical
    }
  };

  return (
    <div className="cbx-feed-page">
      <div className="cbx-feed-layout">
        {/* Main Feed */}
        <main className="cbx-main-feed">
          <FeedContainer />
        </main>

        {/* Right Sidebar - Desktop Only */}
        <FeedSidebar />
      </div>

      {/* Mobile Widget Drawer - Mobile Only */}
      {isMobile && <MobileWidgetDrawer widgets={widgets} />}
    </div>
  );
};

export default FeedPage;
